import React from "react";
import { Twitter, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const links = [{
    label: "The Tech",
    href: "/TheSciencePage"
  }, {
    label: "The Mission",
    href: "#"
  }, {
    label: "Legal",
    href: "#"
  }];
  const socials = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://www.instagram.com/paawan.air/",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section id="footer" ref={ref} className={cn("bg-background py-40 text-foreground transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto flex flex-col items-center px-6">
        {}
        <div className="mb-24">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558603/img/paawan_logo.png" alt="PāAWAN Logo" className="h-7 w-auto object-contain" />
        </div>

        {}
        <div className="mb-24 grid w-full max-w-4xl grid-cols-1 gap-12 text-center md:grid-cols-3 md:gap-8">
          {links.map((link, i) => <div key={i} data-index={i} className="flex flex-col items-center">
              <Link to={link.href} className="text-lg font-medium tracking-wide opacity-60 transition-opacity duration-300 hover:opacity-100">
                {link.label}
              </Link>
            </div>)}
        </div>

        {}
        <div className="mb-24 flex gap-6">
          {socials.map((social, i) => {
          const Icon = social.icon;
          return <Link key={i} to={social.href} newTab aria-label={social.label} className="group flex h-12 w-12 items-center justify-center rounded-full border border-border transition-all duration-300 hover:border-foreground hover:bg-foreground hover:text-background" data-index={i}>
                <Icon className="h-5 w-5 opacity-60 transition-opacity group-hover:opacity-100" />
              </Link>;
        })}
        </div>

        {}
        <div className="text-center">
          <p className="font-serif text-[10px] tracking-wider text-muted-foreground opacity-80">
            पावन पवन, उत्तम जीवन
          </p>
        </div>
      </div>
    </section>;
}